import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
   faStar,
   faUserGraduate,
   faPlayCircle
} from '@fortawesome/free-solid-svg-icons';
import {
   faFacebookF,
   faTwitter,
   faInstagram,
   faLinkedinIn
} from '@fortawesome/free-brands-svg-icons';

const InstructorCard = ({ onClick, name, role, image, rating, students, courses, delay }) => {
   return (
      <div
         className="w-full group"
         data-anim-child={`slide-left delay-${delay}`}
         onClick={onClick}
         style={{ cursor: 'pointer' }}
      >
         <div className="bg-white dark:bg-dark-5 overflow-hidden dark:hover:shadow-purple-300/20 transition-shadow">
            <div className="relative group">
               <img
                  src={image}
                  alt={name}
                  className="w-full h-48 sm:h-56 object-cover"
               />
               <div className="absolute inset-0 bg-dark-2 bg-opacity-0 group-hover:bg-opacity-50 flex
               items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300">
                  <div className="flex space-x-6">
                     <a href="#" className="text-white hover:text-purple-300 transition-colors">
                        <FontAwesomeIcon icon={faFacebookF} size="lg" />
                     </a>
                     <a href="#" className="text-white hover:text-purple-300 transition-colors">
                        <FontAwesomeIcon icon={faTwitter} size="lg" />
                     </a>
                     <a href="#" className="text-white hover:text-purple-300 transition-colors">
                        <FontAwesomeIcon icon={faInstagram} size="lg" />
                     </a>
                     <a href="#" className="text-white hover:text-purple-300 transition-colors">
                        <FontAwesomeIcon icon={faLinkedinIn} size="lg" />
                     </a>
                  </div>
               </div>
            </div>

            <div className="py-6 px-4">
               <h3 className="text-base font-sans text-dark-1 dark:text-white mb-1">{name}</h3>
               <p className="text-gray-600 dark:text-gray-300 text-sm mb-2">{role}</p>

               <div className="flex flex-wrap gap-3 items-start">
                  <div className="flex items-center space-x-1">
                     <FontAwesomeIcon size='xs' icon={faStar} className="text-yellow-500" />
                     <span className="text-xs text-yellow-500 font-medium">{rating}</span>
                  </div>
                  <div className="flex items-center space-x-1">
                     <FontAwesomeIcon size='xs' icon={faUserGraduate} className="text-gray-400 dark:text-gray-500" />
                     <span className="text-xs text-gray-600 dark:text-gray-400">{students} Students</span>
                  </div>
                  <div className="flex items-center space-x-1">
                     <FontAwesomeIcon size='xs' icon={faPlayCircle} className="text-gray-400 dark:text-gray-500" />
                     <span className="text-xs text-gray-600 dark:text-gray-400">{courses} Courses</span>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

export default InstructorCard;